(function() {
    'use strict';
    angular
        .module('consinfApp')
        .factory('ConsInfUser', ConsInfUser);

    ConsInfUser.$inject = ['$resource'];

    function ConsInfUser ($resource) {
        var resourceUrl =  'api/cons-inf-users/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
